import React from 'react';

import {Box, useTheme} from '@mui/material';

interface IProps {
  banner?: string;
}

export const BannerImage: React.FC<IProps> = ({banner}) => {
  const theme = useTheme();

  return (
    <Box
      position="relative"
      width="100%"
      height={216}
      borderRadius={4}
      display="flex"
      alignItems="center"
      justifyContent="center"
      padding={2}
      style={{backgroundColor: 'white'}}>
      <Box
        display="flex"
        style={{border: '4px solid #414141'}}
        width="75%"
        height="100px"
        borderRadius={1}
        marginBottom={4}>
        <Box
          width="100%"
          height="25px"
          style={
            !banner
              ? {backgroundColor: theme.palette.primary.main}
              : {
                  backgroundImage: `url(${banner})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                }
          }></Box>
      </Box>

      <Box
        position="absolute"
        display="flex"
        style={{border: '4px solid #414141', backgroundColor: 'white'}}
        width="29%"
        height="70px"
        top="40%"
        left="22%"
        borderRadius={1}
        marginBottom={4}>
        <Box
          width="100%"
          height="20px"
          style={
            !banner
              ? {backgroundColor: theme.palette.primary.main}
              : {
                  backgroundImage: `url(${banner})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                }
          }></Box>
      </Box>

      <Box
        position="absolute"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        style={{backgroundColor: '#414141'}}
        width="29%"
        height="35px"
        top="72%"
        left="22%"
        borderRadius={1}
        marginBottom={4}
      />

      <Box
        position="absolute"
        display="flex"
        style={{
          border: '4px solid #414141',
          borderBottom: '12px solid #414141',
          backgroundColor: 'white',
        }}
        width="13%"
        height="75px"
        top="45%"
        right="23%"
        borderRadius={1}
        marginBottom={4}>
        <Box
          width="100%"
          height="15px"
          style={
            !banner
              ? {backgroundColor: theme.palette.primary.main}
              : {
                  backgroundImage: `url(${banner})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                }
          }></Box>
        <Box
          width="40%"
          position="absolute"
          height="2px"
          borderRadius={1}
          bottom={-8}
          left={13}
          style={{backgroundColor: 'white'}}
        />
      </Box>
    </Box>
  );
};
